<section class="employee-header">
    <app-header
        [title]="isEditMode ? ('my_profile.my_employees.employee_form.title_edit_employee' | translate) : ('my_profile.my_employees.employee_form.title_add_employee' | translate)"
        [backLinkText]="shopId ? ('my_profile.my_associate_shops.back_to_link' | translate) : ('my_profile.my_employees.employee_form.back_to_employees' | translate)"
        (onBackLinkClick)="onCancel()">
    </app-header>
</section>

<section class="content">
    <section class="employee-form">
        <section class="employee-intro">
            <p class="typography-title-m">{{ 'my_profile.my_employees.employee_form.title_employee_form' | translate }}</p>
        </section>

        <section class="employee-atts">
            <form class="employee-atts-form">
                <div class="employee-atts-row">
                    <div class="form-group">
                        <label for="firstName">{{ 'my_profile.my_employees.employee_form.first_name' | translate }}</label>
                        <input type="text"
                            id="firstName"
                            name="firstName"
                            [(ngModel)]="firstName"
                            (ngModelChange)="markDirty()"
                            [placeholder]="'my_profile.my_employees.employee_form.first_name_placeholder' | translate"
                            aria-label="firstName"
                            required/>
                    </div>

                    <div class="form-group">
                        <label for="lastName">{{ 'my_profile.my_employees.employee_form.last_name' | translate }}</label>
                        <input type="text"
                            id="lastName"
                            name="lastName"
                            [(ngModel)]="lastName"
                            (ngModelChange)="markDirty()"
                            [placeholder]="'my_profile.my_employees.employee_form.last_name_placeholder' | translate"
                            aria-label="lastName"
                            required/>
                    </div>
                </div>

                <div class="employee-atts-row">
                    <div class="form-group">
                        <label for="position">{{ 'my_profile.my_employees.employee_form.role' | translate }}</label>
                        <app-select
                            placeholder="{{ 'my_profile.my_employees.employee_form.role_placeholder' | translate }}"
                            [options]="getUserPositions()"
                            [selectedValue]="selectedPosition"
                            [required]="false"
                            [disabled]="false"
                            [searchable]="false"
                            (selectedValueChanged)="selectUserPosition($event)"
                        ></app-select>
                    </div>

                    <div class="form-group">
                        <label for="primary">{{ 'my_profile.my_employees.employee_form.primary' | translate }}</label>
                        <app-select
                            placeholder="{{ 'my_profile.my_employees.employee_form.primary_placeholder' | translate }}"
                            [options]="primaryOptions"
                            [selectedValue]="selectedPrimary"
                            [required]="false"
                            [disabled]="isPrimaryDisabled"
                            [searchable]="false"
                            (selectedValueChanged)="selectPrimary($event)">
                        </app-select>
                    </div>
                </div>

                <div class="employee-atts-row">
                    <div class="form-group">
                        <label for="email">{{ 'my_profile.my_employees.employee_form.email' | translate }}</label>
                        <input type="text"
                            id="email"
                            name="email"
                            [(ngModel)]="email"
                            (ngModelChange)="markDirty()"
                            [placeholder]="'my_profile.my_employees.employee_form.email_placeholder' | translate"
                            aria-label="email"
                            [disabled]="isEmailDisabled"
                            required/>
                    </div>
                    <div class="form-group">
                        <label for="phone">{{ 'my_profile.my_employees.employee_form.phone' | translate }}</label>
                        <input type="text"
                            id="phone"
                            name="phone"
                            [(ngModel)]="phone"
                            (ngModelChange)="markDirty()"
                            [placeholder]="'my_profile.my_employees.employee_form.phone_placeholder' | translate"
                            aria-label="phone"
                            required/>
                    </div>
                </div>
                <div class="employee-atts-row">
                    <div class="form-group" *ngIf="isEditMode">
                        <label>{{ 'my_profile.my_employees.employee_form.access_we_professionals' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="active"
                            (onChecked)="active = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>   
                    </div>
                    <div class="form-group" *ngIf="userInfo?.accountType === AccountType.FABRICATOR || userInfo?.accountType === AccountType.DISTRIBUTOR || userInfo?.accountType === AccountType.RETAIL">
                        <label>{{ 'my_profile.canjear_puntos' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="enabledGlobalRewards"
                            (onChecked)="enabledGlobalRewards = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>
                    </div>
                    <div class="form-group" *ngIf="userInfo?.accountType === AccountType.FABRICATOR || userInfo?.accountType === AccountType.DISTRIBUTOR || userInfo?.accountType === AccountType.INSTALLER">
                        <label>{{ 'my_profile.my_employees.employee_form.access_e_cosentino' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="enabledEcosentino"
                            (onChecked)="enabledEcosentino = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>
                    </div>
                    <div class="form-group" *ngIf="userInfo?.accountType === AccountType.FABRICATOR || userInfo?.accountType === AccountType.DISTRIBUTOR || userInfo?.accountType === AccountType.INSTALLER">
                        <label>{{ 'my_profile.my_employees.employee_form.access_financial_portal' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="enabledFinancialPortal"
                            (onChecked)="enabledFinancialPortal = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>
                    </div>
                    <div class="form-group" *ngIf="(userInfo?.accountType === AccountType.FABRICATOR || userInfo?.accountType === AccountType.DISTRIBUTOR || userInfo?.accountType === AccountType.RETAIL) && userInfo?.isActiveLeadsB2C">
                        <label>{{ 'my_profile.my_employees.employee_form.notifications_from_leads' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="receiveLeads"
                            (onChecked)="receiveLeads = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>
                    </div>
                    <div class="form-group"  *ngIf="(userInfo?.accountType === AccountType.FABRICATOR || userInfo?.accountType === AccountType.DISTRIBUTOR || userInfo?.accountType === AccountType.RETAIL) && userInfo?.isActiveNexusProgram">
                        <label>{{ 'my_profile.my_employees.employee_form.nexus_access' | translate }}</label>
                        <app-checkbox-toggle
                            [isChecked]="cnexus"
                            (onChecked)="cnexus = $event; markDirty()"
                            [disabled]="userInfo.role != 'ADMIN'">
                        </app-checkbox-toggle>
                    </div>
                </div>
                <span class="help-span">{{ 'my_profile.my_employees.employee_form.help_text_required' | translate }}</span>
            </form>
        </section>
    </section>
    <section class="company-save-button">
        <div class="buttonsSection primaryDefault">
            <app-button
                class="w-full md:w-auto"
                [skin]="'we'"
                [primary]="true"
                [ghost]="true"
                [size]="'medium'"
                (onClick)="onCancel()"
                data-id="buttonId"
            >
                <span>{{ 'my_profile.my_employees.employee_form.cancel_button' | translate }}</span>
            </app-button>
            <app-button
                class="w-full md:w-auto"
                [skin]="'we'"
                [primary]="true"
                [size]="'medium'"
                [disabled]="!canSave()"
                (onClick)="onSave()"
                data-id="buttonId"
            >
                <span>{{ 'my_profile.my_employees.employee_form.save_button' | translate }}</span>
            </app-button>
        </div>
    </section>
</section>

<app-confirm-modal
  [isOpen]="isCreateSuccessModalVisible"
  [title]="'my_profile.new_created_user' | translate"
  [message]="'my_profile.user_created_modal_text' | translate"
  [confirmText]="'my_profile.continue_text' | translate"
  [cancelText]="''"
  [buttonsInRow]="true"
  (onConfirm)="closeSuccessModal()"
  (onClose)="closeSuccessModal()"
/>

<app-confirm-modal
  [isOpen]="isEditSuccessModalVisible"
  [title]="'my_profile.user_updated_modal_title' | translate"
  [message]="'my_profile.datos_salvados' | translate"
  [confirmText]="'my_profile.continue_text' | translate"
  [cancelText]="''"
  [buttonsInRow]="true"
  (onConfirm)="closeSuccessModal()"
  (onClose)="closeSuccessModal()"
/>